mutation ArchiveThread($input: ThreadArchiveInput!) {
    threadArchive(input: $input) {
        thread {
            id
        }
    }
}
